var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 18,
    viewBox: "0 0 35 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1751 15.3986H13.1777C11.6201 15.3986 11.2084 14.3645 11.1915 14.3203L11.1798 14.2839L9.13647 6.59154L9.84692 6.40264L11.8831 14.0689C11.923 14.1501 12.213 14.6635 13.1777 14.6635H19.1197L22.1826 14.2005C22.0967 13.4014 21.9843 11.4808 22.6647 10.0603L16.0534 7.61966L16.7207 6.95894L18.6421 7.45938L23.842 8.91386L23.9431 9.51789L23.5032 10.0611C22.5092 11.6076 22.9513 14.4231 22.9559 14.4513L23.0154 14.8179L19.1751 15.3986Z",
    fill: "#1B1918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8391 2.04431C12.832 1.91219 12.7833 0.753237 13.2412 0.702422L13.2516 0.793505C12.936 0.828788 12.9131 1.70472 12.9308 2.03913L12.8391 2.04431Z",
    fill: "#181C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7219 -3.52859e-05C13.4392 0.0367813 13.2178 0.368131 13.2178 0.771772C13.2178 1.17541 13.4392 1.50695 13.7219 1.54358V-3.52859e-05Z",
    fill: "#181C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1417 14.7616H16.7906C16.517 14.7616 16.2932 14.5379 16.2932 14.2642C16.2932 13.9905 16.517 13.7668 16.7906 13.7668H17.1417C17.4152 13.7668 17.6391 13.9905 17.6391 14.2642C17.6391 14.5379 17.4152 14.7616 17.1417 14.7616Z",
    fill: "#1B1918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6367 3.84277L10.3577 3.60385L11.4616 2.31565C11.5107 2.24393 11.7519 1.92313 12.2046 1.81958C12.6098 1.72639 13.0576 1.83205 13.5348 2.13233L13.339 2.44355C12.2861 1.78085 11.814 2.44719 11.7634 2.52543L11.7479 2.54633L10.6367 3.84277Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4353 2.07231L13.2671 2.33962C12.2142 1.67692 11.7419 2.34326 11.6915 2.4215L11.676 2.4424L10.5648 3.73884L10.3786 3.5793L10.3577 3.60385L10.6367 3.84277L11.7479 2.54633L11.7634 2.52543C11.814 2.44719 12.2861 1.78085 13.339 2.44355L13.5348 2.13233C13.5015 2.11143 13.4683 2.09149 13.4353 2.07231Z",
    fill: "#9CA0A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0702 2.39103C14.0702 2.68576 13.8313 2.92468 13.5366 2.92468C13.2419 2.92468 13.0029 2.68576 13.0029 2.39103C13.0029 2.09631 13.2419 1.85738 13.5366 1.85738C13.8313 1.85738 14.0702 2.09631 14.0702 2.39103Z",
    fill: "#2C3138"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8935 3.31006C14.8515 3.31006 14.8089 3.30047 14.7689 3.28072L13.4841 2.64467C13.3449 2.57545 13.2879 2.40671 13.357 2.2675C13.4258 2.12847 13.5948 2.07172 13.7338 2.14036L15.0183 2.77641C15.1577 2.84563 15.2147 3.01418 15.1457 3.15359C15.0966 3.25253 14.997 3.31006 14.8935 3.31006Z",
    fill: "#181C3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2061 8.72158L18.2477 10.2961C18.2477 10.2961 17.837 10.8438 18.6584 11.186C18.6584 11.186 19.651 11.6652 19.343 13.1028C19.343 13.1028 19.1033 13.6504 19.651 13.6504H21.1913C21.1913 13.6504 21.0544 12.4182 21.7731 12.1787C21.7731 12.1787 21.8074 10.6384 22.4235 9.85122L19.2061 8.72158Z",
    fill: "#1B1918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5916 12.9402H26.0093V12.7563H27.5916V12.9402Z",
    fill: "#181C3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1304 12.7569H31.7127V12.9407H30.1304V12.7569Z",
    fill: "#181C3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4165 11.7036L30.2077 10.3331L30.3668 10.425L29.5757 11.7954L29.4165 11.7036Z",
    fill: "#181C3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1471 11.7949L27.356 10.4246L27.5151 10.3326L28.3063 11.7031L28.1471 11.7949Z",
    fill: "#181C3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8766 10.8662C27.7698 10.8662 26.8726 11.7634 26.8726 12.8702C26.8726 13.9768 27.7698 14.874 28.8766 14.874C29.9832 14.874 30.8804 13.9768 30.8804 12.8702C30.8804 11.7634 29.9832 10.8662 28.8766 10.8662Z",
    fill: "#E3F6F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8766 11.6704C28.2139 11.6704 27.6768 12.2075 27.6768 12.8702C27.6768 13.5327 28.2139 14.0698 28.8766 14.0698C29.5391 14.0698 30.0762 13.5327 30.0762 12.8702C30.0762 12.2075 29.5391 11.6704 28.8766 11.6704Z",
    fill: "url(#paint1_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8763 15.8082C27.2537 15.8082 25.9382 14.4927 25.9382 12.8703C25.9382 11.2477 27.2537 9.93226 28.8763 9.93226C30.4987 9.93226 31.8141 11.2477 31.8141 12.8703C31.8141 14.4927 30.4987 15.8082 28.8763 15.8082ZM28.8763 8.43545C26.4268 8.43545 24.4414 10.421 24.4414 12.8703C24.4414 15.3196 26.4268 17.3052 28.8763 17.3052C31.3255 17.3052 33.311 15.3196 33.311 12.8703C33.311 10.421 31.3255 8.43545 28.8763 8.43545Z",
    fill: "#181C3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8766 15.6636C27.3337 15.6636 26.0831 14.4129 26.0831 12.8703C26.0831 11.3275 27.3337 10.0768 28.8766 10.0768C30.4192 10.0768 31.6699 11.3275 31.6699 12.8703C31.6699 14.4129 30.4192 15.6636 28.8766 15.6636ZM28.8766 9.88334C27.2269 9.88334 25.8896 11.2207 25.8896 12.8703C25.8896 14.5197 27.2269 15.8571 28.8766 15.8571C30.5261 15.8571 31.8633 14.5197 31.8633 12.8703C31.8633 11.2207 30.5261 9.88334 28.8766 9.88334Z",
    fill: "#E3F6F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 5.73746L9.93891 5.69911L9.05762 7.27038L10.4754 8.41992L12.1997 7.34685L11.28 5.73746Z",
    fill: "#181C3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32206 3.77505C6.32206 3.77505 5.47309 4.04101 5.82791 5.20687C5.82791 5.20687 6.20804 6.60069 7.09497 6.51192L6.32206 3.77505Z",
    fill: "#FDDD10"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.322 3.77494L6.82213 6.17071C6.54829 6.19813 6.32275 6.08419 6.14185 5.91356C6.34798 6.24336 6.66071 6.55519 7.09492 6.51182L6.322 3.77494Z",
    fill: "#F5C811"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20278 4.73275C9.20278 4.73275 8.88754 3.27255 6.26604 3.55462C6.26604 3.55462 5.90104 5.49589 7.06243 6.67383C7.06243 6.67383 9.15312 6.47481 9.20278 4.73275Z",
    fill: "#BABCBF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4467 3.85548C8.70825 4.13467 8.76424 4.3943 8.76424 4.3943C8.72244 5.85753 7.24115 6.23228 6.76782 6.31467C6.85304 6.43991 6.95064 6.5605 7.06243 6.67383C7.06243 6.67383 9.15312 6.47481 9.20278 4.73256C9.20278 4.73256 9.09099 4.21482 8.4467 3.85548Z",
    fill: "#9CA0A5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94762 4.72561C8.18579 5.04796 6.82338 5.07021 6.28003 5.06497C6.31472 5.25889 6.36498 5.45925 6.43658 5.65828C8.16489 5.76353 8.94762 4.72561 8.94762 4.72561Z",
    fill: "#9CA0A5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61307 4.33519C8.61307 4.33519 8.12967 3.75878 6.4004 3.77738C6.4004 3.77738 6.3446 4.29799 6.36316 4.521C6.36316 4.521 7.44165 4.26079 8.61307 4.33519Z",
    fill: "url(#paint2_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73181 6.31087C6.73181 6.31087 6.32209 6.35845 6.43137 6.8152C6.43137 6.8152 6.5414 7.35848 6.96044 7.37915L6.73181 6.31087Z",
    fill: "#FDDD10"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73188 6.31087C6.71428 6.31703 6.74065 6.30781 6.73188 6.31087L6.84949 7.23534C6.72011 7.22905 6.62021 7.17265 6.54395 7.09804C6.62423 7.23363 6.75531 7.36897 6.96051 7.37915L6.73188 6.31087Z",
    fill: "#F5C811"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03208 6.84328C8.03208 6.84328 7.95538 6.27918 6.71631 6.22511C6.71631 6.22511 6.45152 6.92748 6.93736 7.43756C6.93736 7.43756 7.92413 7.4903 8.03208 6.84328Z",
    fill: "#BABCBF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72122 6.46996C7.82994 6.59003 7.84356 6.69032 7.84356 6.69032C7.75305 7.2339 7.04241 7.2838 6.81714 7.28566C6.85085 7.33764 6.89073 7.38851 6.93752 7.43756C6.93752 7.43756 7.92428 7.4903 8.03224 6.84328C8.03224 6.84328 8.00501 6.64313 7.72122 6.46996Z",
    fill: "#9CA0A5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91308 6.82512C7.54127 6.89911 6.90331 6.82458 6.64966 6.78968C6.65639 6.86406 6.67025 6.94189 6.69399 7.02053C7.49679 7.16494 7.91308 6.82512 7.91308 6.82512Z",
    fill: "#9CA0A5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77554 6.65918C7.77554 6.65918 7.57746 6.41469 6.76825 6.31655C6.76825 6.31655 6.71693 6.50735 6.71484 6.59191C6.71484 6.59191 7.23154 6.56022 7.77554 6.65918Z",
    fill: "url(#paint3_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97485 11.7036L5.76599 10.3331L5.92514 10.425L5.13395 11.7954L4.97485 11.7036Z",
    fill: "#181C3F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43505 10.8662C3.32835 10.8662 2.43115 11.7634 2.43115 12.8702C2.43115 13.9768 3.32835 14.874 4.43505 14.874C5.54174 14.874 6.43893 13.9768 6.43893 12.8702C6.43893 11.7634 5.54174 10.8662 4.43505 10.8662Z",
    fill: "#E3F6F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43509 11.6704C3.77249 11.6704 3.23535 12.2075 3.23535 12.8702C3.23535 13.5327 3.77249 14.0698 4.43509 14.0698C5.09768 14.0698 5.63482 13.5327 5.63482 12.8702C5.63482 12.2075 5.09768 11.6704 4.43509 11.6704Z",
    fill: "url(#paint4_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43491 15.8082C2.81233 15.8082 1.49696 14.4927 1.49696 12.8703C1.49696 11.2477 2.81233 9.93226 4.43491 9.93226C6.05747 9.93226 7.37273 11.2477 7.37273 12.8703C7.37273 14.4927 6.05747 15.8082 4.43491 15.8082ZM4.43491 8.43545C1.98555 8.43545 0 10.421 0 12.8703C0 15.3196 1.98555 17.3052 4.43491 17.3052C6.88414 17.3052 8.86974 15.3196 8.86974 12.8703C8.86974 10.421 6.88414 8.43545 4.43491 8.43545Z",
    fill: "#181C3F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43486 15.6636C2.89213 15.6636 1.64148 14.4129 1.64148 12.8703C1.64148 11.3275 2.89213 10.0768 4.43486 10.0768C5.97758 10.0768 7.22829 11.3275 7.22829 12.8703C7.22829 14.4129 5.97758 15.6636 4.43486 15.6636ZM4.43486 9.88334C2.78525 9.88334 1.448 11.2207 1.448 12.8703C1.448 14.5197 2.78525 15.8571 4.43486 15.8571C6.08446 15.8571 7.42177 14.5197 7.42177 12.8703C7.42177 11.2207 6.08446 9.88334 4.43486 9.88334Z",
    fill: "#E3F6F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9696 4.34818C8.9696 4.34818 9.66394 3.09814 10.7519 3.4454L12.187 3.83888C12.187 3.83888 11.5157 5.04252 10.7519 4.8805L8.85378 7.93604L7.65015 7.19533L9.22406 4.9963L8.9696 4.34818Z",
    fill: "#181C3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 4.42953C13.1111 4.42953 11.1149 4.13289 11.0071 5.94015C10.8992 7.74742 13.0301 7.72036 13.0301 7.72036H18.1281C18.1281 7.72036 19.8274 7.88224 18.2899 6.64139C18.2899 6.64139 15.5925 4.56453 13.1111 4.42953Z",
    fill: "#2A2726"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7988 6.83495C17.7852 6.84627 17.7689 6.85722 17.7491 6.86792C17.7157 6.88598 17.6762 6.88845 17.6385 6.89039C16.2847 6.96364 14.9231 6.89212 13.5844 6.67752C13.1179 6.60276 12.6132 6.48688 12.3194 6.11665C12.139 5.88923 12.0642 5.58108 12.1204 5.29592C12.1643 5.07316 12.2749 4.77629 12.5079 4.70438C12.8554 4.59738 13.2304 4.69038 13.5783 4.74849C13.9378 4.8087 14.2931 4.88291 14.6408 4.99466C15.1928 5.17226 15.7242 5.4091 16.2391 5.67464C16.5831 5.85237 16.9196 6.04474 17.2481 6.24951C17.3554 6.31626 18.0383 6.63325 17.7988 6.83495Z",
    fill: "url(#paint5_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5446 6.86093C18.54 6.86789 18.5354 6.87456 18.5308 6.88131C18.3375 7.15395 18.0163 7.17006 17.7118 7.17006C17.4242 7.17006 17.1365 7.17006 16.8491 7.17006C15.8472 7.17006 14.8455 7.17006 13.8436 7.17006C13.8436 7.17006 11.7126 7.19709 11.8206 5.38982C11.8432 5.00961 11.9496 4.72234 12.1034 4.50605C11.5897 4.65696 11.0612 5.03433 11.0071 5.94015C10.8992 7.74743 13.0301 7.72037 13.0301 7.72037H18.1281C18.1281 7.72037 19.6186 7.86232 18.5446 6.86093Z",
    fill: "#1B1918"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28745 11.9407C8.61669 9.7146 6.84533 7.93018 4.43478 7.93018C3.07063 7.93018 1.83562 8.4832 0.94165 9.37717C0.94165 9.37717 2.02415 10.175 3.62762 9.47529C3.62762 9.47529 6.86368 8.54245 7.73827 11.3704C7.73827 11.3704 8.05888 14.0234 10.3037 14.3148C10.3037 14.3148 9.75801 13.5026 9.28745 11.9407Z",
    fill: "#1B1918"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78361 13.9199C9.21104 13.7042 8.75313 13.2712 8.41775 12.6271C8.07873 11.9763 7.99762 11.3448 7.99685 11.3387L7.99417 11.3157L7.98727 11.2933C7.54336 9.85797 6.41502 9.06736 4.8103 9.06736C4.11047 9.06736 3.5779 9.21867 3.55558 9.22503L3.53911 9.22983L3.52352 9.23671C3.11957 9.41289 2.7156 9.50225 2.32266 9.50225C1.92096 9.50225 1.59985 9.40772 1.38696 9.31874C2.23495 8.5888 3.30429 8.19047 4.43488 8.19047C6.53121 8.19047 8.33818 9.69213 9.03827 12.0159C9.29713 12.875 9.57767 13.5119 9.78361 13.9199Z",
    fill: "url(#paint6_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57652 12.8955L4.25195 12.689L5.57363 10.613L5.89812 10.8198L4.57652 12.8955Z",
    fill: "#181C3F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65923 13.0678C4.50119 13.2047 4.26224 13.1876 4.12539 13.0297C3.98853 12.8716 4.00562 12.6325 4.16359 12.4958C4.32163 12.3589 4.56057 12.3761 4.6975 12.534C4.83428 12.6919 4.8172 12.9311 4.65923 13.0678Z",
    fill: "#181C3F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69317 11.4585L5.05469 11.052L7.99787 6.52848L8.63641 6.93505L5.69317 11.4585Z",
    fill: "#BABCBF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55485 10.9726C5.50121 10.9379 5.48578 10.8657 5.52054 10.8119L7.42467 7.87489C7.45938 7.82134 7.53186 7.80582 7.58536 7.84074C7.63905 7.87541 7.65439 7.94778 7.61968 8.00141L5.71559 10.9383C5.68075 10.992 5.60848 11.0074 5.55485 10.9726Z",
    fill: "url(#paint7_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20499 7.93909L7.22705 7.31648L9.46826 3.94853L10.446 4.57115L8.20499 7.93909Z",
    fill: "#181C3F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8443 13.6171H23.1057C22.6988 13.6171 22.3657 13.284 22.3657 12.8771C22.3657 12.4701 22.6988 12.1371 23.1057 12.1371H28.8443C29.2512 12.1371 29.5843 12.4701 29.5843 12.8771C29.5843 13.284 29.2512 13.6171 28.8443 13.6171Z",
    fill: "#181C3F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6333 8.6202C32.6333 8.6202 34.56 7.86337 34.4452 10.9138L32.6333 8.6202Z",
    fill: "#E96666"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0966 8.85421L22.9634 10.6001H25.7198C25.7198 10.6001 26.4773 8.78591 28.8046 8.74395C31.9936 8.68643 32.831 11.7656 32.831 11.7656L34.9999 11.7946C34.9999 11.7946 33.101 7.23098 29.1808 6.18959H25.4136L24.0966 8.85421Z",
    fill: "#1B1918"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7466 6.49261C18.7466 6.49261 22.0541 8.5896 24.2192 6.1175C24.2192 6.1175 24.8426 5.18523 25.9243 5.16278H29.675C29.675 5.16278 30.2376 5.09453 30.2376 5.43541L30.3741 6.1858C30.3741 6.1858 30.4251 6.42431 30.0842 6.44137H26.8107C26.8107 6.44137 25.8219 6.42431 25.4468 7.12346C25.4468 7.12346 24.4067 9.83429 23.2305 9.3227C23.2305 9.3227 19.1951 7.92648 19.1897 7.92478C18.7122 7.75952 18.6269 7.16008 18.5222 6.73882C18.4837 6.58407 18.5393 6.40918 18.736 6.48833C18.7396 6.48969 18.7431 6.49104 18.7466 6.49261Z",
    fill: "#2C3138"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3054 5.80822C30.2621 5.84387 30.193 5.87188 30.0841 5.87743H26.8107C26.8107 5.87743 25.8218 5.86034 25.4468 6.55936C25.4468 6.55936 24.4067 9.27012 23.2303 8.75875C23.2303 8.75875 19.195 7.36254 19.1897 7.36068C18.8196 7.23258 18.6852 6.84369 18.5945 6.47897C18.5143 6.51366 18.4953 6.63127 18.5222 6.73882C18.6269 7.16008 18.7122 7.75952 19.1897 7.92478C19.195 7.92648 23.2303 9.3227 23.2303 9.3227C24.4067 9.83429 25.4468 7.12346 25.4468 7.12346C25.8218 6.42431 26.8107 6.44137 26.8107 6.44137H30.0841C30.4251 6.42431 30.3741 6.1858 30.3741 6.1858L30.3054 5.80822Z",
    fill: "#181C3F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3047 11.1917C34.3047 11.1917 31.9749 6.14779 26.5947 6.82027V7.75695C26.5947 7.75695 31.0622 6.89233 34.3047 11.1917Z",
    fill: "url(#paint8_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2997 7.57265C21.2997 7.57265 23.3984 7.80373 24.5729 6.20566L25.3238 6.39816C25.3238 6.39816 24.3035 8.59314 23.5332 8.4584L21.242 7.78456C21.242 7.78456 20.8761 7.63041 21.2997 7.57265Z",
    fill: "url(#paint9_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 11.7761L11.3732 10.3106C11.3732 10.3106 10.7808 9.89253 11.4086 9.58954L13.6276 8.57191C13.6276 8.57191 14.2663 8.20397 14.2337 8.92918L14.288 11.2672L12.8374 11.7761Z",
    fill: "url(#paint10_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9675 9.48989L11.8592 10.412C11.8178 10.4301 11.7988 10.4788 11.817 10.5202C11.835 10.5616 11.8837 10.5808 11.9251 10.5626L14.0335 9.64044C14.0749 9.62239 14.0939 9.5737 14.0758 9.53229C14.0576 9.49085 14.0089 9.47167 13.9675 9.48989Z",
    fill: "url(#paint11_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9585 9.12077L11.6248 10.1415C11.579 10.1616 11.5579 10.2155 11.5778 10.2613C11.598 10.3072 11.6519 10.3282 11.6977 10.3083L14.0313 9.28742C14.0771 9.26742 14.0982 9.21358 14.0783 9.16773C14.0582 9.12188 14.0043 9.10061 13.9585 9.12077Z",
    fill: "url(#paint12_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0037 9.85391L12.0839 10.6938C12.0461 10.7103 12.0288 10.7546 12.0453 10.7924C12.0618 10.83 12.1061 10.8474 12.1439 10.8309L14.0637 9.9912C14.1015 9.97473 14.1187 9.93022 14.1023 9.8927C14.0858 9.85488 14.0415 9.83743 14.0037 9.85391Z",
    fill: "url(#paint13_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0425 10.2314L12.3409 10.9756C12.3075 10.9901 12.2922 11.0294 12.3068 11.0628C12.3214 11.0964 12.3607 11.1117 12.3942 11.0971L14.0956 10.353C14.129 10.3381 14.1444 10.2989 14.1298 10.2655C14.1152 10.2322 14.0759 10.2168 14.0425 10.2314Z",
    fill: "url(#paint14_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0457 10.533L12.5316 11.1954C12.5019 11.2084 12.4882 11.2433 12.5013 11.273C12.5141 11.3027 12.5492 11.3166 12.5789 11.3036L14.0928 10.6412C14.1226 10.6282 14.1364 10.5933 14.1233 10.5635C14.1103 10.5339 14.0754 10.5202 14.0457 10.533Z",
    fill: "url(#paint15_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2483 11.7761L17.7125 10.3106C17.7125 10.3106 18.3048 9.89253 17.677 9.58954L15.4581 8.57191C15.4581 8.57191 14.8195 8.20397 14.8519 8.92918L14.7979 11.2672L16.2483 11.7761Z",
    fill: "url(#paint16_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15.118 9.48989L17.2263 10.412C17.2678 10.4301 17.2867 10.4788 17.2687 10.5202C17.2505 10.5616 17.2018 10.5808 17.1604 10.5626L15.052 9.64044C15.0106 9.62239 14.9916 9.5737 15.0099 9.53229C15.0279 9.49085 15.0766 9.47167 15.118 9.48989Z",
    fill: "url(#paint17_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1271 9.12077L17.461 10.1415C17.5068 10.1616 17.5279 10.2155 17.5077 10.2613C17.4878 10.3072 17.4337 10.3282 17.3879 10.3083L15.0543 9.28742C15.0084 9.26742 14.9873 9.21358 15.0073 9.16773C15.0274 9.12188 15.0813 9.10061 15.1271 9.12077Z",
    fill: "url(#paint18_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0821 9.85391L17.0019 10.6938C17.0397 10.7103 17.0569 10.7546 17.0405 10.7924C17.024 10.83 16.9797 10.8474 16.9419 10.8309L15.0221 9.9912C14.9845 9.97473 14.967 9.93022 14.9835 9.8927C15 9.85488 15.0443 9.83743 15.0821 9.85391Z",
    fill: "url(#paint19_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0431 10.2314L16.7446 10.9756C16.7779 10.9901 16.7933 11.0294 16.7787 11.0628C16.7641 11.0964 16.7248 11.1117 16.6915 11.0971L14.9898 10.353C14.9565 10.3381 14.9411 10.2989 14.9557 10.2655C14.9703 10.2322 15.0096 10.2168 15.0431 10.2314Z",
    fill: "url(#paint20_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.04 10.533L16.5539 11.1954C16.5836 11.2084 16.5974 11.2433 16.5843 11.273C16.5713 11.3027 16.5364 11.3166 16.5065 11.3036L14.9926 10.6412C14.9629 10.6282 14.9493 10.5933 14.9621 10.5635C14.9752 10.5339 15.0102 10.5202 15.04 10.533Z",
    fill: "url(#paint21_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7541 8.39667L11.1528 9.55969C11.0134 9.62201 10.8485 9.55895 10.7862 9.41971C10.724 9.28031 10.7869 9.11536 10.9263 9.05327L13.5277 7.8901C13.6671 7.82801 13.832 7.89084 13.8941 8.03025C13.9564 8.16948 13.8933 8.33435 13.7541 8.39667Z",
    fill: "#181C3F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8741 9.50448L15.2697 8.34798C15.1303 8.28625 15.0668 8.12133 15.1287 7.98192C15.1907 7.84254 15.3554 7.77908 15.4948 7.84102L18.0992 8.99747C18.2386 9.0594 18.3021 9.22412 18.2401 9.36352C18.1782 9.50291 18.0135 9.56636 17.8741 9.50448Z",
    fill: "#181C3F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2394 12.6248H16.4137C16.2107 12.6248 16.0461 12.4603 16.0461 12.2572C16.0461 12.0543 16.2107 11.8896 16.4137 11.8896H22.2394C22.4798 11.8896 22.6582 11.8309 22.7692 11.7153C22.9414 11.5358 22.9316 11.2526 22.9314 11.2497C22.904 10.8532 23.0766 10.6048 23.2263 10.4674C23.7163 10.0177 24.6321 10.1452 24.7349 10.1612C24.9354 10.1924 25.0727 10.3803 25.0415 10.5809C25.0104 10.7813 24.8221 10.9178 24.6223 10.8875C24.3563 10.8474 23.8867 10.8582 23.7232 11.0092C23.7013 11.0294 23.6559 11.0712 23.6651 11.205C23.6691 11.2677 23.691 11.8076 23.308 12.2152C23.0528 12.4869 22.6933 12.6248 22.2394 12.6248Z",
    fill: "#BABCBF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9172 10.2451C24.9168 10.2606 24.9157 10.2764 24.9132 10.2921C24.8819 10.4925 24.6938 10.6288 24.494 10.5987C24.2281 10.5586 23.7585 10.5694 23.5947 10.7205C23.573 10.7406 23.5274 10.7824 23.5368 10.9163C23.5406 10.9787 23.5627 11.5187 23.1797 11.9264C22.9245 12.1981 22.565 12.336 22.1111 12.336H16.2853C16.194 12.336 16.1106 12.3027 16.0463 12.2474C16.0463 12.2507 16.0461 12.2539 16.0461 12.2572C16.0461 12.4603 16.2107 12.6248 16.4137 12.6248H22.2394C22.6933 12.6248 23.0528 12.4869 23.308 12.2152C23.691 11.8076 23.6691 11.2677 23.6651 11.205C23.6559 11.0712 23.7013 11.0294 23.7232 11.0092C23.8867 10.8582 24.3563 10.8474 24.6223 10.8875C24.8221 10.9178 25.0104 10.7813 25.0415 10.5809C25.0618 10.4503 25.0108 10.3251 24.9172 10.2451Z",
    fill: "#9CA0A5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7656 11.4581H25.1977C24.6907 11.4581 24.2798 11.0471 24.2798 10.54C24.2798 10.0332 24.6907 9.62209 25.1977 9.62209H33.7656C34.2726 9.62209 34.6836 10.0332 34.6836 10.54C34.6836 11.0471 34.2726 11.4581 33.7656 11.4581Z",
    fill: "#BABCBF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4968 9.98591C34.5027 10.0281 34.506 10.0712 34.506 10.115C34.506 10.6218 34.095 11.0328 33.588 11.0328H25.0201C24.7214 11.0328 24.4562 10.8902 24.2886 10.6693C24.3513 11.1149 24.7342 11.4581 25.1973 11.4581H33.7652C34.2722 11.4581 34.6831 11.0471 34.6831 10.54C34.6831 10.332 34.6137 10.1398 34.4968 9.98591Z",
    fill: "#9CA0A5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9073 10.4611H25.4285C25.3131 10.4611 25.2188 10.3665 25.2188 10.2511C25.2188 10.1359 25.3131 10.0414 25.4285 10.0414H33.9073C34.0225 10.0414 34.1171 10.1359 34.1171 10.2511C34.1171 10.3665 34.0225 10.4611 33.9073 10.4611Z",
    fill: "url(#paint22_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5113 10.5093C34.5113 10.8224 34.3763 11.0763 34.2096 11.0763C34.0432 11.0763 33.9082 10.8224 33.9082 10.5093C33.9082 10.1961 34.0432 9.94248 34.2096 9.94248C34.3763 9.94248 34.5113 10.1961 34.5113 10.5093Z",
    fill: "#181C3F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4368 12.459C16.4368 13.5274 15.5707 14.3936 14.5022 14.3936C13.4338 14.3936 12.5676 13.5274 12.5676 12.459C12.5676 11.3905 13.4338 10.5243 14.5022 10.5243C15.5707 10.5243 16.4368 11.3905 16.4368 12.459Z",
    fill: "#181C3F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9903 12.459C15.9903 13.2808 15.324 13.947 14.5021 13.947C13.6803 13.947 13.0139 13.2808 13.0139 12.459C13.0139 11.6369 13.6803 10.9708 14.5021 10.9708C15.324 10.9708 15.9903 11.6369 15.9903 12.459Z",
    fill: "url(#paint23_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1003 12.5818C19.1003 13.2422 18.5649 13.7776 17.9045 13.7776C17.2441 13.7776 16.7087 13.2422 16.7087 12.5818C16.7087 11.9214 17.2441 11.386 17.9045 11.386C18.5649 11.386 19.1003 11.9214 19.1003 12.5818Z",
    fill: "#181C3F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8245 12.5816C18.8245 13.0897 18.4127 13.5015 17.9047 13.5015C17.3968 13.5015 16.9849 13.0897 16.9849 12.5816C16.9849 12.0737 17.3968 11.6617 17.9047 11.6617C18.4127 11.6617 18.8245 12.0737 18.8245 12.5816Z",
    fill: "url(#paint24_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4684 14.3203C12.3827 14.3448 12.2925 14.295 12.268 14.2093L11.6667 12.1151C11.6421 12.0296 11.692 11.9395 11.7777 11.9149C11.8632 11.8904 11.9533 11.9402 11.9779 12.0258L12.5792 14.1199C12.6038 14.2055 12.5539 14.2957 12.4684 14.3203Z",
    fill: "#1B1918"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8014 14.9034H12.1659C11.9629 14.9034 11.7983 14.7389 11.7983 14.536C11.7983 14.333 11.9629 14.1684 12.1659 14.1684H20.8014C21.0418 14.1684 21.2199 14.1098 21.331 13.994C21.5032 13.8145 21.4934 13.5314 21.4934 13.5286C21.466 13.1318 21.6385 12.8837 21.7883 12.7462C22.278 12.2966 23.194 12.4239 23.2968 12.44C23.4974 12.471 23.6347 12.659 23.6034 12.8597C23.5722 13.0601 23.3841 13.1965 23.1843 13.1663C22.9183 13.1261 22.4487 13.1368 22.2849 13.2879C22.2633 13.3081 22.2176 13.3499 22.227 13.4839C22.2309 13.5464 22.2529 14.0862 21.87 14.494C21.6148 14.7658 21.2552 14.9034 20.8014 14.9034Z",
    fill: "#BABCBF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4792 12.5237C23.4788 12.5393 23.4775 12.5551 23.475 12.5707C23.4439 12.7713 23.2558 12.9076 23.056 12.8776C22.7898 12.8373 22.3202 12.848 22.1567 12.9992C22.1348 13.0192 22.0894 13.061 22.0986 13.1949C22.1026 13.2576 22.1244 13.7974 21.7417 14.205C21.4863 14.4768 21.1268 14.6147 20.6731 14.6147H12.0375C11.9462 14.6147 11.8628 14.5813 11.7985 14.5262C11.7985 14.5295 11.7983 14.5327 11.7983 14.536C11.7983 14.7389 11.9629 14.9034 12.1659 14.9034H20.8014C21.2552 14.9034 21.6148 14.7658 21.87 14.494C22.2529 14.0862 22.2309 13.5464 22.227 13.4839C22.2176 13.3499 22.2633 13.3081 22.2849 13.2879C22.4487 13.1368 22.9183 13.1261 23.1843 13.1663C23.3841 13.1965 23.5722 13.0601 23.6034 12.8597C23.6238 12.7291 23.5726 12.6039 23.4792 12.5237Z",
    fill: "#9CA0A5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3272 13.7368H23.7592C23.2522 13.7368 22.8413 13.3257 22.8413 12.8189C22.8413 12.3121 23.2522 11.9009 23.7592 11.9009H32.3272C32.834 11.9009 33.2449 12.3121 33.2449 12.8189C33.2449 13.3257 32.834 13.7368 32.3272 13.7368Z",
    fill: "#BABCBF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M33.059 12.2645C33.0649 12.3069 33.068 12.3498 33.068 12.3938C33.068 12.9006 32.657 13.3117 32.1502 13.3117H23.5823C23.2836 13.3117 23.0182 13.1688 22.8506 12.9479C22.9135 13.3938 23.2964 13.7368 23.7595 13.7368H32.3274C32.8342 13.7368 33.2452 13.3257 33.2452 12.8189C33.2452 12.6106 33.1757 12.4187 33.059 12.2645Z",
    fill: "#9CA0A5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4686 12.7399H23.9901C23.8746 12.7399 23.7803 12.6453 23.7803 12.5299C23.7803 12.4145 23.8746 12.3202 23.9901 12.3202H32.4686C32.5841 12.3202 32.6786 12.4145 32.6786 12.5299C32.6786 12.6453 32.5841 12.7399 32.4686 12.7399Z",
    fill: "url(#paint25_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0735 12.788C33.0735 13.1011 32.9385 13.3547 32.7718 13.3547C32.6054 13.3547 32.4702 13.1011 32.4702 12.788C32.4702 12.4748 32.6054 12.2209 32.7718 12.2209C32.9385 12.2209 33.0735 12.4748 33.0735 12.788Z",
    fill: "#181C3F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0126 3.91439L11.2101 3.69848L10.5664 4.6814C10.5664 4.6814 11.2719 4.80949 12.0126 3.91439Z",
    fill: "url(#paint26_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76186 5.29848L9.10281 4.91279C8.89399 4.79068 8.82323 4.51974 8.94537 4.31092C9.06752 4.1021 9.33828 4.03134 9.5471 4.15349L10.2062 4.5391C10.415 4.66125 10.4859 4.93197 10.3638 5.14081C10.2414 5.34964 9.97068 5.42057 9.76186 5.29848Z",
    fill: "#9CA0A5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54709 4.15345C9.33827 4.03131 9.06751 4.10206 8.94536 4.31088C8.92542 4.34482 8.91085 4.3803 8.90088 4.41654C8.93789 4.48384 8.99273 4.54233 9.06329 4.58356L9.72235 4.96917C9.93117 5.09134 10.2019 5.02054 10.3243 4.81174C10.344 4.7778 10.3588 4.74233 10.3686 4.70609C10.3317 4.63878 10.2769 4.5803 10.2061 4.53907L9.54709 4.15345Z",
    fill: "#BABCBF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0109 4.79005L9.19823 4.34518C9.1687 4.32907 9.15777 4.29168 9.17407 4.26234C9.19018 4.23281 9.22738 4.22188 9.25691 4.23799L10.0696 4.68286C10.0989 4.69897 10.1098 4.73636 10.0937 4.7657C10.0776 4.79523 10.0404 4.80616 10.0109 4.79005Z",
    fill: "url(#paint27_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2193 14.2454H18.832C18.7298 14.2454 18.646 14.1618 18.646 14.0594C18.646 13.957 18.7298 13.8734 18.832 13.8734H21.2193C21.3217 13.8734 21.4055 13.957 21.4055 14.0594C21.4055 14.1618 21.3217 14.2454 21.2193 14.2454Z",
    fill: "#1B1918"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.3577,
    y1: 2.81478,
    x2: 13.5349,
    y2: 2.81478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.5588,
    y1: 13.5525,
    x2: 28.2877,
    y2: 12.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#90A5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC6C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.9034,
    y1: 4.18236,
    x2: 6.44078,
    y2: 4.14835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.45033,
    y1: 6.56198,
    x2: 6.76866,
    y2: 6.45721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 5.11743,
    y1: 13.5525,
    x2: 3.84627,
    y2: 12.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#90A5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC6C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10.8076,
    y1: 2.60737,
    x2: 14.8816,
    y2: 6.21841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0276819,
    stopColor: "#4B4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -3.61536,
    y1: 6.7675,
    x2: 9.31184,
    y2: 11.7495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0276819,
    stopColor: "#4B4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 7.21278,
    y1: 8.42578,
    x2: 5.92161,
    y2: 10.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 32.9414,
    y1: 9.7466,
    x2: 27.5465,
    y2: 7.08611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0276819,
    stopColor: "#4B4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 21.0953,
    y1: 7.33509,
    x2: 25.3239,
    y2: 7.33509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0276819,
    stopColor: "#3D4047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505A68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 12.7041,
    y1: 6.23771,
    x2: 12.7041,
    y2: 9.13486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 11.8254,
    y1: 10.5315,
    x2: 13.2266,
    y2: 9.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 11.6887,
    y1: 10.2281,
    x2: 13.0899,
    y2: 9.59645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 11.9655,
    y1: 10.842,
    x2: 13.3668,
    y2: 10.2104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 12.1104,
    y1: 11.1637,
    x2: 13.5116,
    y2: 10.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 12.2213,
    y1: 11.4101,
    x2: 13.6225,
    y2: 10.7785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 16.3817,
    y1: 6.23771,
    x2: 16.3817,
    y2: 9.13486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 14.6217,
    y1: 9.34627,
    x2: 16.7236,
    y2: 10.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 14.758,
    y1: 9.04253,
    x2: 16.8598,
    y2: 9.98433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 14.4825,
    y1: 9.65721,
    x2: 16.5843,
    y2: 10.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 14.3381,
    y1: 9.97902,
    x2: 16.4399,
    y2: 10.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 14.2277,
    y1: 10.2257,
    x2: 16.3295,
    y2: 11.1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 25.2188,
    y1: 10.2511,
    x2: 34.1171,
    y2: 10.2511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 14.5021,
    y1: 8.94799,
    x2: 14.5021,
    y2: 11.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 17.9047,
    y1: 10.4115,
    x2: 17.9047,
    y2: 12.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 23.7803,
    y1: 12.5299,
    x2: 32.6786,
    y2: 12.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 12.367,
    y1: 2.4446,
    x2: 11.0636,
    y2: 4.68637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#474C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 10.2544,
    y1: 4.82686,
    x2: 9.37106,
    y2: 4.3816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32225,
    stopColor: "#BABCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.4b3208abca579ce3c280f75ab184a016.svg";
export { ForwardRef as ReactComponent };